import { LoadingOutlined } from '@ant-design/icons';
import { Card, Spin } from 'antd';
import classNames from 'classnames';
import { lazy, Suspense } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { isMobile } from '@/utils/ua';
const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

const LazyEntry = lazy(() => import('./lazyEntry'));

export const CreateApiForm = ({ isEdit = false }: { isEdit?: boolean }) => {
  const [$t] = useI18nContext();

  const title = !isEdit ? $t('Create New Key') : $t('editApi');

  return (
    <Card
      title={title}
      className={classNames(
        'bybit-card-with-title',
        isMobile({ tablet: true }) && 'api-form-card-h5',
      )}
      bordered={false}
      headStyle={{ borderBottomColor: 'var(--bds-gray-ele-line)' }}
    >
      <Suspense
        fallback={
          <Spin indicator={antIcon}>
            <div style={{ height: 'calc(100vh - 420px)' }}></div>
          </Spin>
        }
      >
        <LazyEntry isEdit={isEdit} />
      </Suspense>
    </Card>
  );
};
